<template>
  <label
    class="relative max-w-full flex overflow-hidden duration focus-within:outline-auto"
    :class="[
      brandClasses.container,
      disabled ? 'bg-grey-90 b-grey-50 c-grey-30' : invalid ? 'b-red-30' : 'b-grey-40 hover:b-grey-10',
      { 'bg-white cursor-pointer': !disabled },
    ]"
    data-test-id="select-sort"
  >
    <span class="sr-only" data-test-id="select-sort-label">
      {{ label }}
    </span>
    <base-select
      v-model="modelValue"
      class="full flex items-center"
      :class="[
        brandClasses.text,
        !disabled && (modelValue ? 'c-grey-10' : 'c-grey-20'),
      ]"
      :disabled
      :label-formatter="labelFormatter"
      :options
      :placeholder
      @update:model-value="$emit('change', $event)"
    />
    <vf-icon
      class="pointer-events-none"
      :class="[brandClasses.icon, disabled ? 'c-grey-50' : 'c-grey-10']"
      dir="down"
      name="chevron"
      :size="iconSize"
    />
  </label>
</template>

<script lang="ts" setup>
import type { SelectOption } from '#types/components/base/select'

const { label } = defineProps<{
  /**
   * Defines the label text
   */
  label: string
  /**
   * Defines list of options
   */
  options: (string | SelectOption)[] | (() => Promise<SelectOption[]>)
  /**
   * Defines placeholder when no selection
   */
  placeholder?: string
  /**
   * Defines disabled state
   */
  disabled?: boolean
  /**
   * Defines invalid state
   */
  invalid?: boolean
}>()

defineEmits<{ change: [value?: string | number | object] }>()

const modelValue = defineModel<string | number | object>()

const { iconSize, sort: { brandClasses } } = useAppConfig().components.vf.select

const labelFormatter = (option?: SelectOption) => `${label}: ${option?.label ?? ''}`
</script>
